import React from 'react';
import './DifferentiatorSection.css';

const DifferentiatorSection = () => {
  const differentiators = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
      ),
      title: "Just a Framework",
      description: "Pay only for the AI credits you use. No seat licenses, no hidden fees.",
      highlight: "Pay per credit"
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
        </svg>
      ),
      title: "Just for Test Creation",
      description: "Focused on what matters. Create tests with AI, not a bloated platform.",
      highlight: "Focused tooling"
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
        </svg>
      ),
      title: "Optionally a Platform",
      description: "Need more? Upgrade when ready. Monthly subscription, cancel anytime.",
      highlight: "Your choice"
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
        </svg>
      ),
      title: "No Vendor Lock-In",
      description: "Create tests, export them, run anywhere. Your CI, your cloud, your way.",
      highlight: "100% portable"
    }
  ];

  return (
    <div className="differentiator-section">
      <div className="differentiator-header">
        <span className="differentiator-badge">We're Different</span>
        <h2>Not another testing platform</h2>
        <p>Create with AI. Own forever. Run anywhere with it.</p>
      </div>

      <div className="differentiator-grid">
        {differentiators.map((item, index) => (
          <div key={index} className="differentiator-card">
            <div className="differentiator-icon">
              {item.icon}
            </div>
            <div className="differentiator-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <span className="differentiator-highlight">{item.highlight}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="differentiator-cta">
        <div className="cta-text">
          <span className="cta-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </span>
          <span>Create your first test in under 60 seconds, then use it anywhere. It's that simple. And then do wonders with it... <a href="/documentation" target="_blank" rel="noopener noreferrer" className="docs-link">Docs for devs</a></span>
        </div>
      </div>
    </div>
  );
};

export default DifferentiatorSection;
